import React from 'react'
import AppBar from '../components/AppBar'
import Markdown from '../components/Markdown'

/**
 * 계정 삭제 안내 전용 공개 페이지 (스토어 제출용).
 * URL: /account-deletion
 */
const CONTENT = `# TASTEE 계정 삭제 안내

TASTEE 앱에서 계정과 데이터를 삭제하는 방법을 안내합니다.

## 앱에서 직접 삭제하기

1. TASTEE 앱 실행 → 마이페이지
2. 설정 → 계정 관리
3. **계정 삭제** 선택 후 확인

## 삭제되는 데이터

탈퇴 즉시 다음 정보가 삭제됩니다.

- 휴대전화번호, 닉네임, 아이디, 프로필 이미지
- 작성한 기록 및 사진
- 연락처 대조 정보, 푸시 토큰

## 계정 복구

**탈퇴한 계정은 복구할 수 없습니다.** 다시 이용하시려면 새로 가입해야 합니다.

사용하던 아이디는 탈퇴 후 **14일간 보호**되며, 그 기간이 지나면 다른 사용자가 사용할 수 있습니다.

## 법령에 따라 보관되는 데이터

- 서비스 방문 기록: 3개월 (통신비밀보호법)
- 소비자 불만·분쟁처리 기록: 3년 (전자상거래법)

앱을 이용할 수 없는 경우 admin@tastee.kr 로 삭제를 요청할 수 있습니다.`

const AccountDeletion: React.FC = () => {
  return (
    <div className="w-full h-full flex flex-col">
      <AppBar title="계정 삭제 안내" isBottomBorder />

      <div className="flex-1 app-container overflow-y-auto scrollbar-hide p-16px">
        <Markdown content={CONTENT} />
      </div>
    </div>
  )
}

export default AccountDeletion
